export default __webpack_public_path__ + "static/media/home_page.32fafe87.png";